var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 6.323,
    viewBox: "0 0 10.5 6.323"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.271 3.848L8.631.587a.97.97 0 011.338 0 .9.9 0 010 1.308L5.945 5.801a.97.97 0 01-1.348 0L.525 1.895a.915.915 0 010-1.308.97.97 0 011.338 0z",
    fill: "#194dff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}

export default SvgArrowDownBlue;